import getUserCountryFromClient from "@/lib/user-context/getUserCountryFromClient";

const EXCLUDED_COUNTRIES = [
  "GB", // United Kingdom
  "CA", // Canada
  "FR", // France
  "DE", // Germany
  "ES", // Spain
  "IT", // Italy
  "SG", // Singapore
  "BE", // Belgium
  "AU", // Australia
  "GR", // Greece
  "PT", // Portugal
  "NL", // Netherlands
  "HK", // Hong Kong
  "AT", // Austria
  "NZ", // New Zealand
  "PL", // Poland
  "IE", // Ireland
  "RO", // Romania
  "SE", // Sweden
  "BG", // Bulgaria
  "CY", // Cyprus
  "DK", // Denmark
  "HU", // Hungary
  "SK", // Slovakia
  "CZ", // Czech Republic
  "EE", // Estonia
  "LT", // Lithuania
  "LU", // Luxembourg
  "SI", // Slovenia
  "HR", // Croatia
  "FI", // Finland
  "LV", // Latvia
  "MT", // Malta
];

const LSE_BRANDS = ["lse"];

export const isLSE = (brand: string): boolean => {
  if (!brand) return false;

  const brandKeys = brand.split(",").map((key) => key.trim().toLowerCase());
  return brandKeys.some((brandKey) => LSE_BRANDS.includes(brandKey));
};

export const shouldUseCrossSellUrl = (
  brand: string,
  productVariant: string,
): boolean => {
  const isLSEForm = isLSE(brand);

  if (!isLSEForm) {
    return false;
  }
  const isDegreeProgram =
    productVariant &&
    ["Masters", "Bachelors", "Doctorate"].includes(productVariant);

  if (!isDegreeProgram) {
    return false;
  }

  const userLocation = getUserCountryFromClient() || "US";

  const isInternational = userLocation !== "US";
  const isNotInExcludedCountries = !EXCLUDED_COUNTRIES.includes(userLocation);

  return isInternational && isNotInExcludedCountries;
};

export const getCrossSellThankYouUrl = (
  brand: string,
  pathname: string,
  postSubmitUrl: string,
): string => {
  // For LSE, append /thank-you-lse to the current pathname with the original post submit URL as a parameter
  if (isLSE(brand)) {
    const encodedUrl = encodeURIComponent(postSubmitUrl);
    return `${pathname}/thank-you-lse?applicationUrl=${encodedUrl}`;
  }
  return postSubmitUrl;
};
